import { render, staticRenderFns } from "./SetupSidebar.vue?vue&type=template&id=28ae75e8&scoped=true&"
import script from "./SetupSidebar.vue?vue&type=script&lang=js&"
export * from "./SetupSidebar.vue?vue&type=script&lang=js&"
import style0 from "./SetupSidebar.vue?vue&type=style&index=0&id=28ae75e8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ae75e8",
  null
  
)

export default component.exports